import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import './Legal.css';

function Privacy() {
  const { i18n } = useTranslation();
  const [showLangMenu, setShowLangMenu] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // localStorage'dan dili oku ve i18n'e uygula
    const savedLanguage = localStorage.getItem('rux_language');
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  const lang = i18n.language === 'tr' ? 'tr' : 'en';

  const changeLanguage = (newLang) => {
    i18n.changeLanguage(newLang);
    localStorage.setItem('rux_language', newLang);
    setShowLangMenu(false);
  };

  return (
    <div className="legal-page">
      {/* Navbar */}
      <header className="legal-header">
        <div className="legal-container">
          <nav className="legal-navbar">
            <Link to="/" className="legal-logo">
              <img src="/images/ruxLogo-40.png" className="logo-image" alt="RUX Engine" />
              <h3 className="logo-text">RuX Engine</h3>
            </Link>
            <div className="legal-nav-links">
              <Link to="/">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
              <Link to="/terms">{lang === 'tr' ? 'Kullanım Koşulları' : 'Terms'}</Link>
              <Link to="/privacy" className="active">{lang === 'tr' ? 'Gizlilik' : 'Privacy'}</Link>
              
              {/* Dil Seçimi */}
              <div className="language-selector">
                <button 
                  className="lang-btn"
                  onClick={() => setShowLangMenu(!showLangMenu)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 12px',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '6px',
                    color: '#000',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'}
                  onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'}
                >
                  <Globe size={16} />
                  <span>{lang === 'tr' ? 'TR' : 'EN'}</span>
                </button>
                
                {showLangMenu && (
                  <div 
                    className="lang-menu"
                    style={{
                      position: 'absolute',
                      top: '100%',
                      right: '0',
                      marginTop: '8px',
                      background: 'rgba(30, 30, 40, 0.95)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                      zIndex: 1000,
                      minWidth: '120px'
                    }}
                  >
                    <button
                      onClick={() => changeLanguage('tr')}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        background: lang === 'tr' ? 'rgba(99, 102, 241, 0.2)' : 'transparent',
                        border: 'none',
                        color: 'white',
                        cursor: 'pointer',
                        textAlign: 'left',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (lang !== 'tr') e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      }}
                      onMouseLeave={(e) => {
                        if (lang !== 'tr') e.currentTarget.style.background = 'transparent';
                      }}
                    >
                      🇹🇷 Türkçe
                    </button>
                    <button
                      onClick={() => changeLanguage('en')}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        background: lang === 'en' ? 'rgba(99, 102, 241, 0.2)' : 'transparent',
                        border: 'none',
                        color: 'white',
                        cursor: 'pointer',
                        textAlign: 'left',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (lang !== 'en') e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      }}
                      onMouseLeave={(e) => {
                        if (lang !== 'en') e.currentTarget.style.background = 'transparent';
                      }}
                    >
                      🇬🇧 English
                    </button>
                  </div>
                )}
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Content */}
      <div className="legal-content-wrapper">
        <div className="legal-content">
          {lang === 'tr' ? <PrivacyTR /> : <PrivacyEN />}
        </div>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-container">
          <div className="footer-content">
            <div className="footer-col">
              <h4>RUX Engine</h4>
              <p>{lang === 'tr' ? 'Web site izleme hizmeti' : 'Website monitoring service'}</p>
            </div>
            <div className="footer-col">
              <h4>{lang === 'tr' ? 'Yasal' : 'Legal'}</h4>
              <Link to="/terms">{lang === 'tr' ? 'Kullanım Koşulları' : 'Terms of Service'}</Link>
              <Link to="/privacy">{lang === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy'}</Link>
            </div>
            <div className="footer-col">
              <h4>{lang === 'tr' ? 'İletişim' : 'Contact'}</h4>
              <p>support@ruxengine.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 RUX Engine. {lang === 'tr' ? 'Tüm hakları saklıdır.' : 'All rights reserved.'}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// TÜRKÇE İÇERİK - FULL VERSION (311 satır)
// ═══════════════════════════════════════════════════════════════
function PrivacyTR() {
  return (
    <>
      <h1>GİZLİLİK POLİTİKASI VE KİŞİSEL VERİLERİN KORUNMASI</h1>
      <p><strong>Son Güncelleme:</strong> 26 Şubat 2026</p>
      
      <p>RUX Engine olarak, kullanıcılarımızın kişisel verilerinin gizliliğini ve güvenliğini en üst düzeyde korumayı taahhüt ederiz. Bu Gizlilik Politikası, Türkiye Cumhuriyeti <strong>6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK)</strong> ve Avrupa Birliği <strong>General Data Protection Regulation (GDPR)</strong> düzenlemelerine tam uyum sağlamak amacıyla hazırlanmıştır.</p>

      <hr />

      <h2>1. VERİ SORUMLUSU</h2>
      <p>6698 sayılı KVKK ve GDPR kapsamında veri sorumlusu:</p>
      <ul>
        <li><strong>Şirket Adı:</strong> RUX Engine</li>
        <li><strong>E-posta:</strong> admin@ruxengine.com</li>
        <li><strong>KVKK/GDPR İletişim:</strong> support@ruxengine.com</li>
      </ul>

      <hr />

      <h2>2. TOPLANAN KİŞİSEL VERİLER</h2>
      <p>RUX Engine hizmetini kullanırken aşağıdaki kişisel verileriniz işlenmektedir:</p>

      <h3>2.1. Hesap Bilgileri</h3>
      <ul>
        <li>Ad ve Soyad</li>
        <li>E-posta adresi</li>
        <li>E-posta CC adresi (isteğe bağlı - bildirimler için)</li>
        <li>Şifre (bcrypt ile şifrelenmiş olarak)</li>
        <li>Telefon numarası (ülke kodu dahil)</li>
        <li>Dil tercihi (Türkçe/İngilizce)</li>
        <li>Ülke bilgisi (tarih/saat formatı için)</li>
        <li>E-posta bildirim tercihi (açık/kapalı)</li>
        <li>Hesap rolü (kullanıcı/admin)</li>
        <li>Hesap durumu (aktif/pasif)</li>
        <li>Hesap oluşturma tarihi</li>
        <li>Terms & Privacy kabul tarihleri</li>
      </ul>

      <h3>2.2. İzleme Verileri</h3>
      <ul>
        <li>İzlenen web sitesi URL'leri</li>
        <li>Domain onay durumu (beklemede/onaylı/reddedildi)</li>
        <li>Domain sona erme tarihi ve kayıt firması</li>
        <li>SSL sertifika bilgileri ve sona erme tarihi</li>
        <li>Uptime/downtime kayıtları (7 gün saklanır)</li>
        <li>HTTP yanıt kodları ve yanıt süreleri</li>
        <li>DNS, TCP, SSL, HTTP katman durumları</li>
        <li>Yönlendirme sayısı ve final URL</li>
        <li>Hata mesajları</li>
        <li>Ekran görüntüleri (maksimum 7 gün saklanır, sonra otomatik silinir)</li>
        <li>Screenshot hash değeri (tekrar önleme için)</li>
      </ul>

      <h3>2.3. Fatura Profili Bilgileri</h3>
      <p>Ödeme işlemleri ve yasal fatura düzenleme yükümlülüğü kapsamında aşağıdaki bilgiler toplanır:</p>
      <ul>
        <li><strong>Kişisel Bilgiler:</strong> Ad, soyad, e-posta adresi</li>
        <li><strong>Telefon Numarası:</strong> Ülke kodu dahil tam telefon numarası (ödeme doğrulama için PayTR'ye iletilir)</li>
        <li><strong>Adres Bilgileri:</strong> Ülke, şehir, açık adres, posta kodu</li>
        <li><strong>Müşteri Tipi:</strong> Bireysel veya Kurumsal</li>
        <li><strong>Bireysel Müşteriler (Türkiye):</strong> TC Kimlik Numarası (11 haneli)</li>
        <li><strong>Kurumsal Müşteriler (Türkiye):</strong> Şirket adı, vergi numarası (VKN), vergi dairesi</li>
        <li><strong>Kurumsal Müşteriler (Yurtdışı):</strong> Şirket adı, KDV numarası (VAT Number - isteğe bağlı)</li>
      </ul>
      <p><strong>ÖNEMLİ:</strong> Bu bilgiler Türk vergi mevzuatı (VUK) ve e-fatura/e-arşiv fatura düzenleme zorunluluğu kapsamında toplanmaktadır. TC Kimlik No ve vergi bilgileri şifrelenmiş olarak saklanır.</p>

      <h3>2.4. Abonelik ve Ödeme Bilgileri</h3>
      <ul>
        <li><strong>ÖNEMLİ:</strong> Kredi kartı bilgileriniz RUX Engine sisteminde <strong>ASLA SAKLANMAZ</strong></li>
        <li>Ödeme işlemleri güvenli üçüncü taraf ödeme sağlayıcıları üzerinden gerçekleştirilir</li>
        <li>Abonelik planı bilgileri (plan adı, süre, fiyat)</li>
        <li>Abonelik başlangıç ve bitiş tarihleri</li>
        <li>Ödeme durumu (beklemede/tamamlandı/başarısız/iade)</li>
        <li>Ödeme gateway işlem ID'si (Stripe vb.)</li>
        <li>Ödeme tarihi ve tutarı</li>
        <li>Para birimi (USD/TRY)</li>
        <li>Fatura bilgileri (<strong>5 yıl saklanır - yasal zorunluluk</strong>)</li>
      </ul>

      <h3>2.5. Ücretsiz Deneme Kayıtları</h3>
      <ul>
        <li>Ücretsiz deneme kullanım tarihleri</li>
        <li>Trial kullanılan domain URL'leri (normalize edilmiş)</li>
        <li>Trial kullanım sayısı (kullanıcı başına maksimum 2)</li>
        <li><strong>ÖNEMLİ:</strong> Hesap silinse bile trial kayıtları korunur (kötüye kullanım önlemi)</li>
      </ul>

      <h3>2.6. Teknik Veriler ve Loglar</h3>
      <ul>
        <li>IP adresi</li>
        <li>Tarayıcı türü ve sürümü (User Agent)</li>
        <li>İşletim sistemi</li>
        <li>Erişim zamanları</li>
        <li>Oturum bilgileri (session cookies)</li>
        <li>Hesap silme logları (<strong>5 yıl saklanır - KVKK/GDPR uyumu</strong>)</li>
        <li>Şifre sıfırlama token'ları (kullanıldıktan sonra silinir)</li>
      </ul>

      <hr />

      <h2>3. VERİLERİN İŞLENME AMAÇLARI VE HUKUKİ DAYANAKLAR</h2>

      <h3>3.1. Hizmet Sunumu</h3>
      <ul>
        <li><strong>Hukuki Dayanak:</strong> Sözleşmenin ifası (KVKK m.5/2-c, GDPR m.6/1-b)</li>
        <li><strong>Amaç:</strong> Web sitesi izleme hizmetinin sağlanması</li>
        <li><strong>İşleme Süresi:</strong> Hesap aktif olduğu sürece</li>
      </ul>

      <h3>3.2. Bildirim Gönderimi</h3>
      <ul>
        <li><strong>Hukuki Dayanak:</strong> Açık rıza (KVKK m.5/1, GDPR m.6/1-a)</li>
        <li><strong>Amaç:</strong> Hata durumlarında e-posta bildirimi</li>
        <li><strong>Vazgeçme Hakkı:</strong> İstediğiniz zaman bildirim ayarlarını kapatabilirsiniz</li>
      </ul>

      <h3>3.3. Ekran Görüntüsü Saklama</h3>
      <ul>
        <li><strong>Hukuki Dayanak:</strong> Meşru menfaat (KVKK m.5/2-f, GDPR m.6/1-f)</li>
        <li><strong>Amaç:</strong> Hata tespiti ve kullanıcıya kanıt sunma</li>
        <li><strong>Saklama Süresi:</strong> Maksimum 7 gün (otomatik silme)</li>
      </ul>

      <h3>3.4. Fatura ve Ödeme İşlemleri</h3>
      <ul>
        <li><strong>Hukuki Dayanak:</strong> Yasal yükümlülük (KVKK m.5/2-a, GDPR m.6/1-c) ve sözleşmenin ifası (KVKK m.5/2-c, GDPR m.6/1-b)</li>
        <li><strong>Amaç:</strong> Vergi mevzuatı gereği fatura düzenlenmesi, ödeme işlemlerinin gerçekleştirilmesi</li>
        <li><strong>İşlenen Veriler:</strong> Ad, soyad, adres, telefon numarası, TC Kimlik No / vergi numarası</li>
        <li><strong>Üçüncü Taraf Paylaşımı:</strong> Telefon numarası ödeme doğrulama amacıyla PayTR ödeme sağlayıcısına iletilir</li>
        <li><strong>Saklama Süresi:</strong> 5 yıl (VUK Madde 253 - vergi mevzuatı zorunluluğu)</li>
      </ul>

      <h3>3.5. Diğer Yasal Yükümlülükler</h3>
      <ul>
        <li><strong>Hukuki Dayanak:</strong> Yasal yükümlülük (KVKK m.5/2-a, GDPR m.6/1-c)</li>
        <li><strong>Amaç:</strong> Vergi, muhasebe ve diğer yasal gerekliliklerin yerine getirilmesi</li>
      </ul>

      <hr />

      <h2>4. VERİLERİN AKTARILMASI</h2>

      <h3>4.1. Üçüncü Taraf Hizmetler</h3>
      <p>Verileriniz sadece hizmetin sunulması için gerekli olan aşağıdaki taraflarla paylaşılır:</p>
      <ul>
        <li><strong>PayTR (Ödeme Sağlayıcısı):</strong> Kredi kartı işlemleri için (PCI-DSS uyumlu). Ödeme sırasında ad, soyad, e-posta, telefon numarası ve adres bilgileri ödeme doğrulama amacıyla PayTR'ye iletilir</li>
        <li><strong>E-posta Servisleri:</strong> Bildirim gönderimi için</li>
        <li><strong>Bulut Depolama:</strong> Veri barındırma için (AB/Türkiye sunucuları)</li>
      </ul>

      <h3>4.2. Uluslararası Veri Aktarımı</h3>
      <ul>
        <li>Verileriniz öncelikli olarak <strong>Türkiye</strong> veya <strong>Avrupa Birliği</strong> sunucularında saklanır</li>
        <li>AB dışına veri aktarımı yapılması durumunda <strong>Standart Sözleşme Hükümleri (SCC)</strong> kullanılır</li>
        <li>GDPR Madde 44-49 hükümlerine tam uyum sağlanır</li>
      </ul>

      <h3>4.3. Kamu Otoriteleri</h3>
      <p>Verileriniz sadece <strong>yasal zorunluluk</strong> halinde (mahkeme kararı, emniyet müdürlüğü talebi vb.) resmi makamlara aktarılır.</p>

      <hr />

      <h2>5. VERİ GÜVENLİĞİ</h2>

      <h3>5.1. Teknik Önlemler</h3>
      <ul>
        <li><strong>SSL/TLS Şifreleme:</strong> Tüm veri iletimi 256-bit şifreleme ile korunur</li>
        <li><strong>Şifre Güvenliği:</strong> Bcrypt hash algoritması ile şifrelenir</li>
        <li><strong>Güvenlik Duvarı:</strong> 7/24 saldırı tespiti ve önleme sistemi</li>
        <li><strong>Düzenli Yedekleme:</strong> Günlük otomatik yedekleme</li>
      </ul>

      <h3>5.2. İdari Önlemler</h3>
      <ul>
        <li>Yetkili personel dışında veriye erişim engellenir</li>
        <li>Tüm çalışanlar <strong>gizlilik sözleşmesi</strong> imzalar</li>
        <li>Yıllık güvenlik denetimleri yapılır</li>
      </ul>

      <h3>5.3. Otomatik Silme ve Saklama Süreleri</h3>
      <ul>
        <li><strong>Ekran Görüntüleri:</strong> 7 gün sonra otomatik silinir</li>
        <li><strong>Domain Kontrol Kayıtları:</strong> 7 gün sonra otomatik silinir (partition cleanup)</li>
        <li><strong>Şifre Sıfırlama Token'ları:</strong> Kullanıldıktan sonra hemen silinir</li>
      </ul>

      <h3>5.4. Uzun Süreli Saklama (Yasal Zorunluluk)</h3>
      <ul>
        <li><strong>Fatura Kayıtları:</strong> 5 yıl saklanır (VUK Madde 253 - Vergi mevzuatı gereği)</li>
        <li><strong>Fatura Profili Bilgileri:</strong> Ad, soyad, adres, telefon, TC Kimlik No / vergi bilgileri fatura kayıtlarıyla birlikte 5 yıl saklanır</li>
        <li><strong>Hesap Silme Logları:</strong> 5 yıl saklanır (KVKK/GDPR denetim gereksinimi)</li>
        <li><strong>Trial Kullanım Kayıtları:</strong> Kalıcı saklanır (kötüye kullanım önlemi)</li>
      </ul>

      <h3>5.5. Hesap Silme</h3>
      <p>Hesabınızı sildiğinizde:</p>
      <ul>
        <li>Kişisel verileriniz (ad, email, şifre) <strong>hemen</strong> silinir</li>
        <li>Domain kayıtlarınız ve kontrol geçmişiniz <strong>hemen</strong> silinir</li>
        <li>Fatura profili bilgileriniz (ad, soyad, adres, telefon, TC Kimlik No / vergi bilgileri) fatura kayıtlarıyla birlikte <strong>5 yıl</strong> saklanır (yasal zorunluluk)</li>
        <li>Fatura kayıtları ve hesap silme logları <strong>5 yıl</strong> saklanır (yasal zorunluluk)</li>
        <li>Trial kullanım kayıtları <strong>korunur</strong> (kötüye kullanım önlemi)</li>
      </ul>

      <hr />

      <h2>6. KVKK VE GDPR KAPSAMINDA HAKLARINIZ</h2>

      <h3>6.1. Bilgi Alma Hakkı (KVKK m.11, GDPR m.15)</h3>
      <p>Hangi verilerinizin işlendiğini öğrenme hakkınız vardır.</p>

      <h3>6.2. Düzeltme Hakkı (KVKK m.11, GDPR m.16)</h3>
      <p>Yanlış veya eksik verilerin düzeltilmesini talep edebilirsiniz.</p>

      <h3>6.3. Silme Hakkı / "Unutulma Hakkı" (KVKK m.11, GDPR m.17)</h3>
      <p>Verilerinizin silinmesini talep edebilirsiniz. Bu durumda:</p>
      <ul>
        <li>Hesabınız kalıcı olarak kapatılır</li>
        <li>Tüm kişisel verileriniz 30 gün içinde silinir</li>
        <li>Sadece yasal zorunluluklar için gerekli fatura bilgileri saklanır (5 yıl)</li>
      </ul>

      <h3>6.4. İtiraz Hakkı (KVKK m.11, GDPR m.21)</h3>
      <p>Veri işleme faaliyetlerine itiraz edebilirsiniz.</p>

      <h3>6.5. Taşınabilirlik Hakkı (GDPR m.20)</h3>
      <p>Verilerinizi yapılandırılmış, yaygın kullanılan formatta (JSON, CSV) talep edebilirsiniz.</p>

      <h3>6.6. Otomatik Karar Verme ve Profilleme (GDPR m.22)</h3>
      <p>RUX Engine otomatik profilleme veya skorlama yapmaz.</p>

      <hr />

      <h2>7. HAKLARINIZI NASIL KULLANABİLİRSİNİZ?</h2>

      <h3>Başvuru Yöntemleri:</h3>
      <ul>
        <li><strong>E-posta:</strong> support@ruxengine.com</li>
        <li><strong>Konu:</strong> "KVKK/GDPR Veri Sahibi Başvurusu"</li>
      </ul>

      <h3>Başvuru İçeriği:</h3>
      <ul>
        <li>Ad, soyad</li>
        <li>Kayıtlı e-posta adresi</li>
        <li>Talebinizin açık ifadesi (örn: "Verilerimin silinmesini talep ediyorum")</li>
        <li>Kimlik doğrulama için nüfus cüzdanı fotokopisi (KVKK gereği)</li>
      </ul>

      <h3>Yanıt Süresi:</h3>
      <ul>
        <li><strong>KVKK:</strong> En geç 30 gün içinde</li>
        <li><strong>GDPR:</strong> En geç 1 ay içinde (karmaşık durumlarda 3 aya kadar uzatılabilir)</li>
      </ul>

      <hr />

      <h2>8. ÇEREZLER (COOKIES)</h2>
      
      <p>RUX Engine yalnızca <strong>zorunlu çerezler</strong> kullanır. Analitik, reklam veya takip amaçlı çerezler kullanılmaz.</p>

      <h3>8.1. Kullanılan Çerezler</h3>
      <ul>
        <li><strong>Oturum Çerezi (Authentication Token):</strong> Giriş yapmış kullanıcıların kimlik doğrulaması için kullanılır</li>
        <li><strong>Tip:</strong> HttpOnly, Secure, SameSite cookie</li>
        <li><strong>Süre:</strong> 7 gün (veya oturumu kapatana kadar)</li>
        <li><strong>İçerik:</strong> Şifrelenmiş kullanıcı ID'si (JWT token)</li>
        <li><strong>Zorunluluk:</strong> Hizmetin çalışması için gereklidir</li>
      </ul>

      <h3>8.2. Kullanılmayan Çerezler</h3>
      <ul>
        <li>❌ Analitik çerezler (Google Analytics vb.) kullanılmaz</li>
        <li>❌ Reklam çerezleri kullanılmaz</li>
        <li>❌ Sosyal medya takip çerezleri kullanılmaz</li>
        <li>❌ Üçüncü taraf çerezleri kullanılmaz</li>
      </ul>
      
      <p><strong>Not:</strong> Sadece zorunlu çerezler kullanıldığı için çerez onay banner'ı gösterilmez (GDPR Madde 6/1-b: Sözleşmenin ifası için gerekli).</p>

      <hr />

      <h2>9. VERİ SIZINTISI BİLDİRİMİ</h2>

      <h3>GDPR Madde 33-34 Gereği:</h3>
      <ul>
        <li>Veri ihlali tespit edildiğinde <strong>72 saat içinde</strong> Kişisel Verileri Koruma Kurumu'na bildirilir</li>
        <li>Kullanıcılar <strong>derhal e-posta</strong> ile bilgilendirilir</li>
        <li>Alınan önlemler ve kullanıcının yapması gerekenler detaylı açıklanır</li>
      </ul>

      <hr />

      <h2>10. ÇOCUKLARIN GİZLİLİĞİ</h2>
      <ul>
        <li>RUX Engine hizmeti <strong>18 yaş altı</strong> bireyler için tasarlanmamıştır</li>
        <li>18 yaş altı kullanıcı tespiti halinde hesap kapatılır ve veriler silinir</li>
        <li>Veliler çocuklarının RUX Engine kullanmasını engellemekle sorumludur</li>
      </ul>

      <hr />

      <h2>11. POLİTİKA DEĞİŞİKLİKLERİ</h2>
      <ul>
        <li>Bu politika güncellendiğinde kullanıcılar <strong>e-posta ile bilgilendirilir</strong></li>
        <li>Önemli değişiklikler için <strong>yeniden onay</strong> istenebilir</li>
        <li>Güncel sürüm her zaman <strong>ruxengine.com/privacy</strong> adresinde yayınlanır</li>
      </ul>

      <hr />

      <h2>12. KVKK BAŞVURU VE ŞİKAYET HAKLARI</h2>

      <h3>Kişisel Verileri Koruma Kurumu (KVKK):</h3>
      <ul>
        <li><strong>Adres:</strong> Nasuh Akar Mah. Ziya Gökalp Cad. No:15 Çankaya/Ankara</li>
        <li><strong>Website:</strong> kvkk.gov.tr</li>
        <li><strong>E-posta:</strong> kvkk@kvkk.gov.tr</li>
      </ul>

      <h3>Avrupa Veri Koruma Kurulu (GDPR):</h3>
      <ul>
        <li><strong>Website:</strong> edpb.europa.eu</li>
        <li>İlgili AB üyesi ülkenin veri koruma otoritesine başvurabilirsiniz</li>
      </ul>

      <hr />

      <h2>13. İLETİŞİM</h2>
      <p>Gizlilik ile ilgili tüm sorularınız için:</p>
      <ul>
        <li><strong>Genel Destek:</strong> support@ruxengine.com</li>
        <li><strong>KVKK/GDPR Başvuruları:</strong> support@ruxengine.com</li>
        <li><strong>Veri Sorumlusu:</strong> RUX Engine</li>
      </ul>

      <hr />

      <p><strong>Son Güncelleme Tarihi:</strong> 26 Şubat 2026</p>
      <p><em>Bu belge KVKK (6698 sayılı kanun) ve GDPR (Regulation (EU) 2016/679) mevzuatına uygun olarak hazırlanmıştır.</em></p>
    </>
  );
}

// ═══════════════════════════════════════════════════════════════
// ENGLISH CONTENT - FULL VERSION
// ═══════════════════════════════════════════════════════════════
function PrivacyEN() {
  return (
    <>
      <h1>PRIVACY POLICY AND DATA PROTECTION</h1>
      <p><strong>Last Updated:</strong> February 26, 2026</p>
      
      <p>At RUX Engine, we are committed to protecting the privacy and security of our users' personal data at the highest level. This Privacy Policy is prepared in full compliance with Turkey's <strong>Law No. 6698 on Protection of Personal Data (KVKK)</strong> and the European Union's <strong>General Data Protection Regulation (GDPR)</strong>.</p>

      <hr />

      <h2>1. DATA CONTROLLER</h2>
      <p>Under KVKK and GDPR, the data controller is:</p>
      <ul>
        <li><strong>Company Name:</strong> RUX Engine</li>
        <li><strong>Email:</strong> admin@ruxengine.com</li>
        <li><strong>KVKK/GDPR Contact:</strong> support@ruxengine.com</li>
      </ul>

      <hr />

      <h2>2. PERSONAL DATA COLLECTED</h2>
      <p>When using RUX Engine services, the following personal data is processed:</p>

      <h3>2.1. Account Information</h3>
      <ul>
        <li>Full Name</li>
        <li>Email Address</li>
        <li>Email CC Address (optional - for notifications)</li>
        <li>Password (encrypted with bcrypt)</li>
        <li>Phone number (including country code)</li>
        <li>Language preference (Turkish/English)</li>
        <li>Country information (for date/time format)</li>
        <li>Email notification preference (on/off)</li>
        <li>Account role (user/admin)</li>
        <li>Account status (active/inactive)</li>
        <li>Account creation date</li>
        <li>Terms & Privacy acceptance dates</li>
      </ul>

      <h3>2.2. Monitoring Data</h3>
      <ul>
        <li>Monitored website URLs</li>
        <li>Domain approval status (pending/approved/rejected)</li>
        <li>Domain expiration date and registrar</li>
        <li>SSL certificate information and expiration date</li>
        <li>Uptime/downtime records (stored for 7 days)</li>
        <li>HTTP response codes and response times</li>
        <li>DNS, TCP, SSL, HTTP layer status</li>
        <li>Redirect count and final URL</li>
        <li>Error messages</li>
        <li>Screenshots (stored for maximum 7 days, then auto-deleted)</li>
        <li>Screenshot hash value (for deduplication)</li>
      </ul>

      <h3>2.3. Billing Profile Information</h3>
      <p>The following information is collected for payment processing and legal invoicing obligations:</p>
      <ul>
        <li><strong>Personal Information:</strong> First name, last name, email address</li>
        <li><strong>Phone Number:</strong> Full phone number including country code (transmitted to PayTR for payment verification)</li>
        <li><strong>Address Information:</strong> Country, city, full address, postal code</li>
        <li><strong>Customer Type:</strong> Individual or Company</li>
        <li><strong>Individual Customers (Turkey):</strong> Turkish National ID Number (TC Kimlik No - 11 digits)</li>
        <li><strong>Company Customers (Turkey):</strong> Company name, tax number (VKN), tax office</li>
        <li><strong>Company Customers (International):</strong> Company name, VAT number (optional)</li>
      </ul>
      <p><strong>IMPORTANT:</strong> This information is collected under Turkish tax legislation (Tax Procedure Law) and e-invoice/e-archive invoicing requirements. National ID and tax information are stored in encrypted form.</p>

      <h3>2.4. Subscription and Payment Information</h3>
      <ul>
        <li><strong>IMPORTANT:</strong> Credit card information is <strong>NEVER STORED</strong> in RUX Engine systems</li>
        <li>Payments are processed through secure third-party payment providers</li>
        <li>Subscription plan information (plan name, duration, price)</li>
        <li>Subscription start and end dates</li>
        <li>Payment status (pending/completed/failed/refunded)</li>
        <li>Payment gateway transaction ID (Stripe, etc.)</li>
        <li>Payment date and amount</li>
        <li>Currency (USD/TRY)</li>
        <li>Invoice information (<strong>retained for 5 years - legal requirement</strong>)</li>
      </ul>

      <h3>2.5. Free Trial Records</h3>
      <ul>
        <li>Free trial usage dates</li>
        <li>Trial-used domain URLs (normalized)</li>
        <li>Trial usage count (maximum 2 per user)</li>
        <li><strong>IMPORTANT:</strong> Trial records are preserved even after account deletion (abuse prevention)</li>
      </ul>

      <h3>2.6. Technical Data and Logs</h3>
      <ul>
        <li>IP address</li>
        <li>Browser type and version (User Agent)</li>
        <li>Operating system</li>
        <li>Access times</li>
        <li>Session information (session cookies)</li>
        <li>Account deletion logs (<strong>retained for 5 years - KVKK/GDPR compliance</strong>)</li>
        <li>Password reset tokens (deleted after use)</li>
      </ul>

      <hr />

      <h2>3. PURPOSES AND LEGAL BASIS FOR DATA PROCESSING</h2>

      <h3>3.1. Service Provision</h3>
      <ul>
        <li><strong>Legal Basis:</strong> Contract performance (KVKK Art. 5/2-c, GDPR Art. 6/1-b)</li>
        <li><strong>Purpose:</strong> Providing website monitoring service</li>
        <li><strong>Retention Period:</strong> While account is active</li>
      </ul>

      <h3>3.2. Notification Delivery</h3>
      <ul>
        <li><strong>Legal Basis:</strong> Explicit consent (KVKK Art. 5/1, GDPR Art. 6/1-a)</li>
        <li><strong>Purpose:</strong> Email notifications for error situations</li>
        <li><strong>Opt-out Right:</strong> You can disable notifications anytime</li>
      </ul>

      <h3>3.3. Screenshot Storage</h3>
      <ul>
        <li><strong>Legal Basis:</strong> Legitimate interest (KVKK Art. 5/2-f, GDPR Art. 6/1-f)</li>
        <li><strong>Purpose:</strong> Error detection and evidence provision</li>
        <li><strong>Retention Period:</strong> Maximum 7 days (automatic deletion)</li>
      </ul>

      <h3>3.4. Invoicing and Payment Processing</h3>
      <ul>
        <li><strong>Legal Basis:</strong> Legal obligation (KVKK Art. 5/2-a, GDPR Art. 6/1-c) and contract performance (KVKK Art. 5/2-c, GDPR Art. 6/1-b)</li>
        <li><strong>Purpose:</strong> Issuing invoices as required by tax legislation, processing payments</li>
        <li><strong>Data Processed:</strong> Name, surname, address, phone number, National ID / tax number</li>
        <li><strong>Third-Party Sharing:</strong> Phone number is transmitted to PayTR payment provider for payment verification</li>
        <li><strong>Retention Period:</strong> 5 years (Tax Procedure Law Article 253 - tax legislation requirement)</li>
      </ul>

      <h3>3.5. Other Legal Obligations</h3>
      <ul>
        <li><strong>Legal Basis:</strong> Legal obligation (KVKK Art. 5/2-a, GDPR Art. 6/1-c)</li>
        <li><strong>Purpose:</strong> Compliance with tax, accounting, and other legal requirements</li>
      </ul>

      <hr />

      <h2>4. DATA SHARING</h2>

      <h3>4.1. Third-Party Services</h3>
      <p>Your data is only shared with the following parties necessary for service provision:</p>
      <ul>
        <li><strong>PayTR (Payment Provider):</strong> For credit card transactions (PCI-DSS compliant). During payment, your name, surname, email, phone number and address information are transmitted to PayTR for payment verification</li>
        <li><strong>Email Services:</strong> For notification delivery</li>
        <li><strong>Cloud Storage:</strong> For data hosting (EU/Turkey servers)</li>
      </ul>

      <h3>4.2. International Data Transfers</h3>
      <ul>
        <li>Your data is primarily stored on servers in <strong>Turkey</strong> or the <strong>European Union</strong></li>
        <li>If data transfer outside the EU is necessary, <strong>Standard Contractual Clauses (SCC)</strong> are used</li>
        <li>Full compliance with GDPR Articles 44-49</li>
      </ul>

      <h3>4.3. Public Authorities</h3>
      <p>Your data will only be transferred to official authorities in cases of <strong>legal obligation</strong> (court order, law enforcement request, etc.).</p>

      <hr />

      <h2>5. DATA SECURITY</h2>

      <h3>5.1. Technical Measures</h3>
      <ul>
        <li><strong>SSL/TLS Encryption:</strong> All data transmission protected with 256-bit encryption</li>
        <li><strong>Password Security:</strong> Encrypted using Bcrypt hash algorithm</li>
        <li><strong>Firewall:</strong> 24/7 intrusion detection and prevention system</li>
        <li><strong>Regular Backups:</strong> Daily automatic backups</li>
      </ul>

      <h3>5.2. Administrative Measures</h3>
      <ul>
        <li>Access to data is restricted to authorized personnel only</li>
        <li>All employees sign <strong>confidentiality agreements</strong></li>
        <li>Annual security audits are conducted</li>
      </ul>

      <h3>5.3. Automatic Deletion and Retention Periods</h3>
      <ul>
        <li><strong>Screenshots:</strong> Automatically deleted after 7 days</li>
        <li><strong>Domain Check Records:</strong> Automatically deleted after 7 days (partition cleanup)</li>
        <li><strong>Password Reset Tokens:</strong> Deleted immediately after use</li>
      </ul>

      <h3>5.4. Long-term Retention (Legal Requirement)</h3>
      <ul>
        <li><strong>Invoice Records:</strong> Retained for 5 years (Tax Law Article 253 - tax legislation requirement)</li>
        <li><strong>Billing Profile Information:</strong> Name, surname, address, phone, National ID / tax information retained alongside invoice records for 5 years</li>
        <li><strong>Account Deletion Logs:</strong> Retained for 5 years (KVKK/GDPR audit requirement)</li>
        <li><strong>Trial Usage Records:</strong> Retained permanently (abuse prevention)</li>
      </ul>

      <h3>5.5. Account Deletion</h3>
      <p>When you delete your account:</p>
      <ul>
        <li>Your personal data (name, email, password) is deleted <strong>immediately</strong></li>
        <li>Your domain records and check history are deleted <strong>immediately</strong></li>
        <li>Your billing profile information (name, surname, address, phone, National ID / tax information) is retained alongside invoice records for <strong>5 years</strong> (legal requirement)</li>
        <li>Invoice records and deletion logs are retained for <strong>5 years</strong> (legal requirement)</li>
        <li>Trial usage records are <strong>preserved</strong> (abuse prevention)</li>
      </ul>

      <hr />

      <h2>6. YOUR RIGHTS UNDER KVKK AND GDPR</h2>

      <h3>6.1. Right to Information (KVKK Art. 11, GDPR Art. 15)</h3>
      <p>You have the right to learn which of your data is being processed.</p>

      <h3>6.2. Right to Rectification (KVKK Art. 11, GDPR Art. 16)</h3>
      <p>You can request correction of inaccurate or incomplete data.</p>

      <h3>6.3. Right to Erasure / "Right to be Forgotten" (KVKK Art. 11, GDPR Art. 17)</h3>
      <p>You can request deletion of your data. In this case:</p>
      <ul>
        <li>Your account will be permanently closed</li>
        <li>All personal data will be deleted within 30 days</li>
        <li>Only invoice information required by law will be retained (5 years)</li>
      </ul>

      <h3>6.4. Right to Object (KVKK Art. 11, GDPR Art. 21)</h3>
      <p>You can object to data processing activities.</p>

      <h3>6.5. Right to Data Portability (GDPR Art. 20)</h3>
      <p>You can request your data in structured, commonly used format (JSON, CSV).</p>

      <h3>6.6. Automated Decision-Making and Profiling (GDPR Art. 22)</h3>
      <p>RUX Engine does not perform automated profiling or scoring.</p>

      <hr />

      <h2>7. HOW TO EXERCISE YOUR RIGHTS</h2>

      <h3>Application Methods:</h3>
      <ul>
        <li><strong>Email:</strong> support@ruxengine.com</li>
        <li><strong>Subject:</strong> "KVKK/GDPR Data Subject Request"</li>
      </ul>

      <h3>Application Content:</h3>
      <ul>
        <li>Full name</li>
        <li>Registered email address</li>
        <li>Clear statement of request (e.g., "I request deletion of my data")</li>
        <li>ID copy for identity verification (required by KVKK)</li>
      </ul>

      <h3>Response Time:</h3>
      <ul>
        <li><strong>KVKK:</strong> Within 30 days maximum</li>
        <li><strong>GDPR:</strong> Within 1 month maximum (can be extended to 3 months for complex cases)</li>
      </ul>

      <hr />

      <h2>8. COOKIES</h2>
      
      <p>RUX Engine uses only <strong>essential cookies</strong>. No analytics, advertising, or tracking cookies are used.</p>

      <h3>8.1. Cookies Used</h3>
      <ul>
        <li><strong>Session Cookie (Authentication Token):</strong> Used for authentication of logged-in users</li>
        <li><strong>Type:</strong> HttpOnly, Secure, SameSite cookie</li>
        <li><strong>Duration:</strong> 7 days (or until logout)</li>
        <li><strong>Content:</strong> Encrypted user ID (JWT token)</li>
        <li><strong>Necessity:</strong> Required for the service to function</li>
      </ul>

      <h3>8.2. Cookies NOT Used</h3>
      <ul>
        <li>❌ Analytics cookies (Google Analytics, etc.) are not used</li>
        <li>❌ Advertising cookies are not used</li>
        <li>❌ Social media tracking cookies are not used</li>
        <li>❌ Third-party cookies are not used</li>
      </ul>
      
      <p><strong>Note:</strong> Since only essential cookies are used, no cookie consent banner is displayed (GDPR Article 6/1-b: Necessary for contract performance).</p>

      <hr />

      <h2>9. DATA BREACH NOTIFICATION</h2>

      <h3>As Required by GDPR Articles 33-34:</h3>
      <ul>
        <li>Data breaches are reported to the Personal Data Protection Authority <strong>within 72 hours</strong> of detection</li>
        <li>Users are <strong>immediately notified via email</strong></li>
        <li>Measures taken and actions users should take are explained in detail</li>
      </ul>

      <hr />

      <h2>10. CHILDREN'S PRIVACY</h2>
      <ul>
        <li>RUX Engine service is not designed for individuals <strong>under 18 years old</strong></li>
        <li>If users under 18 are detected, their accounts will be closed and data deleted</li>
        <li>Parents are responsible for preventing their children from using RUX Engine</li>
      </ul>

      <hr />

      <h2>11. POLICY CHANGES</h2>
      <ul>
        <li>Users will be <strong>notified via email</strong> when this policy is updated</li>
        <li><strong>Re-consent</strong> may be requested for significant changes</li>
        <li>The current version is always published at <strong>ruxengine.com/privacy</strong></li>
      </ul>

      <hr />

      <h2>12. KVKK APPLICATION AND COMPLAINT RIGHTS</h2>

      <h3>Personal Data Protection Authority (KVKK):</h3>
      <ul>
        <li><strong>Address:</strong> Nasuh Akar Mah. Ziya Gökalp Cad. No:15 Çankaya/Ankara, Turkey</li>
        <li><strong>Website:</strong> kvkk.gov.tr</li>
        <li><strong>Email:</strong> kvkk@kvkk.gov.tr</li>
      </ul>

      <h3>European Data Protection Board (GDPR):</h3>
      <ul>
        <li><strong>Website:</strong> edpb.europa.eu</li>
        <li>You can apply to the data protection authority of the relevant EU member state</li>
      </ul>

      <hr />

      <h2>13. CONTACT</h2>
      <p>For all privacy-related questions:</p>
      <ul>
        <li><strong>General Support:</strong> support@ruxengine.com</li>
        <li><strong>KVKK/GDPR Applications:</strong> support@ruxengine.com</li>
        <li><strong>Data Controller:</strong> RUX Engine</li>
      </ul>

      <hr />

      <p><strong>Last Update Date:</strong> February 26, 2026</p>
      <p><em>This document is prepared in compliance with KVKK (Law No. 6698) and GDPR (Regulation (EU) 2016/679) legislation.</em></p>
    </>
  );
}

export default Privacy;
